import { planPostageTasks, postageTaskTrackingNumbers } from '../../../../shared/collection-postage-tasks.js'

/**
 * A preview of the hand jobs a cancel will leave, for the drawer before staff
 * press the button. The rule is the shared one the worker uses to record them.
 * The worker also counts Royal Mail rows in its own database, which the
 * browser cannot see, so the cancel answer stays the record of what was made.
 *
 * `collection` is the shipment (carrier, send_type, tracking_number), `parcels`
 * the boxes from GET parcels, `prismBookedPickup` true when Prism booked a
 * FedEx pickup, which cancel removes by itself. Returns [{ kind, trackingNumbers }].
 */
export function previewHandTasks({ collection, parcels, prismBookedPickup }) {
  const kinds = planPostageTasks({ collection, parcels, royalMailShipments: [], hadPrismPickup: prismBookedPickup })
  return kinds.map(kind => ({ kind, trackingNumbers: postageTaskTrackingNumbers(kind, { collection, parcels }) }))
}
